import { UiControlConstants } from "../../common";
import { AlertAction } from "../alert";

export class CollectConfirmConcludeBinding {
  /** Sets the delegate implementation for edits. */
  editDelegate = "<";
   /** Use auto height for correct spacing allowing overflow to work properly (wizard steps)*/
  autoHeight = "<?";
}

export interface CollectConfirmConcludeDelegate {
  canConfirm: () => boolean;
  canSubmit: () => boolean;
  setEditState: (editState: any) => void;
  onSubmit: () => ng.IPromise<SubmissionSuccess>;
  onFinished: (finishState: any) => void;
}

export interface SubmissionFailure {
  isRetryable: boolean;
  message: string;
  header?: string;
  details?: string;
}

export interface SubmissionSuccess {
  message?: string;
}

export enum FinishState {
  Completed,
  Cancelled,
  Errored
}

export class CollectConfirmConcludeController {
  concludeSuccess: boolean;
  concludeFailureMessage: string;
  concludeSuccessMessage: string;
  canRetrySubmission: boolean;
  editDelegate: CollectConfirmConcludeDelegate;
  concludeFailureHeader: string;
  concludeDetailsMessage: string;
  showDetailsMessage: boolean = false;
  alertActions: AlertAction[];
  autoHeight: boolean;

  // @ngInject
  constructor(private uiControlConstants: UiControlConstants) {}

  onSubmit(busyPromiseSetter: (promise: ng.IPromise<any>) => void) {
    this.canRetrySubmission = false;
    let resultPromise = this.editDelegate.onSubmit();
    busyPromiseSetter(
      resultPromise.then(
        (success: SubmissionSuccess) => {
          this.concludeSuccess = true;
          this.concludeSuccessMessage = success.message ? success.message : "You have not specified a success message!";
        },
        (failure: SubmissionFailure) => {
          if (failure.isRetryable) {
            this.canRetrySubmission = true;
          }

          this.concludeSuccess = false;
          this.concludeFailureMessage = failure.message;
          this.concludeFailureHeader = failure.header ? failure.header : "";
          this.concludeDetailsMessage = failure.details ? failure.details : "";
          if (failure.header) {
            this.showDetailsMessage = true;
            this.alertActions = [{ linkText: "Report this issue", url: "https://aka.ms/csticm", biId: "alert_action" }];
          } else {
            this.showDetailsMessage = false;
          }
        }
      )
    );
  }

  setWizardState(wizardState: any) {
    if (this.editDelegate && this.editDelegate.setEditState) {
      this.editDelegate.setEditState(wizardState);
    }
  }

  finishWizard() {
    let finishState = this.uiControlConstants.finishState.Cancelled;
    if (this.concludeFailureMessage) {
      finishState = this.uiControlConstants.finishState.Errored;
    } else if (this.concludeSuccess) {
      finishState = this.uiControlConstants.finishState.Completed;
    }

    this.editDelegate.onFinished(finishState);
  }
}
export const sdCollectConfirmConclude: ng.IComponentOptions = {
  controller: CollectConfirmConcludeController,
  templateUrl: "../ShellCommon/Controls/collect-confirm-conclude/collect-confirm-conclude.html",
  bindings: <any>new CollectConfirmConcludeBinding(),
  transclude: {
    collect: "collectContent",
    conclude: "?concludeContent",
    confirm: "confirmContent"
  }
};
